/**
 * Die Plattform-Rolle in Worten — für Profil, Kontozeile und Admin-Interface.
 *
 * Eine Tabelle und nicht drei Verzweigungen: Bis HM-116 stand dieselbe
 * Übersetzung in Profil und Rahmen je als `if … ? … :`, und das Bewohnerkonto
 * wäre in beiden still als „Standardkonto" erschienen. Ein `Record` über den
 * Typ aus dem SDK meldet eine neue Rolle beim Übersetzen.
 */
import type { ApiComponents } from "@hausmeter/sdk";

export type PlatformRole = ApiComponents["schemas"]["PlatformRole"];

const PLATFORM_ROLE_LABELS: Readonly<Record<PlatformRole, string>> = {
  resident: "Bewohnerkonto",
  standard: "Standardkonto",
  extended: "Erweitertes Konto",
  admin: "Administrator",
};

export function platformRoleLabel(role: PlatformRole): string {
  return PLATFORM_ROLE_LABELS[role];
}

/**
 * Ob der Nutzer einen **eigenen** Account hat — er ist `owner` mindestens
 * eines. Ohne ihn gibt es keinen Ort, an dem eine Anlage stehen könnte, und das
 * Profil bietet die erste eigene an (`POST /auth/me/own-site`).
 */
export function ownsAccount(accounts: readonly { readonly role: string }[]): boolean {
  return accounts.some((account) => account.role === "owner");
}
